<template>
  <div :class="className" :style="{ height: height, width: width }" />
</template>

<script>
import { debounce } from '@/utils/util'
import resize from './mixins/resize'
import * as echarts from 'echarts'
require('echarts/theme/macarons') // echarts theme

export default {
  mixins: [resize],
  props: {
    className: {
      type: String,
      default: 'chart'
    },
    width: {
      type: String,
      default: '100%'
    },
    height: {
      type: String,
      default: '100%'
    },
    autoResize: {
      type: Boolean,
      default: true
    },
    chartData: {
      type: Object,
      default: () => {
        return {}
      }
    },
    title: {
      type: String,
      default: null
    }
  },
  data() {
    return {
      chart: null
    }
  },
  watch: {
    chartData: {
      deep: true,
      handler(val) {
        this.setOptions(val)
      }
    }
  },
  mounted() {
    this.initChart()
    // if (this.autoResize) {
    //   this.__resizeHandler = debounce(() => {
    //     if (this.chart) {
    //       this.chart.resize()
    //     }
    //   }, 100)
    //   window.addEventListener('resize', this.__resizeHandler)
    //   setTimeout(() => {
    //     if (this.chart) {
    //       this.chart.resize()
    //     }
    //   }, 600)
    // }
  },
  beforeDestroy() {
    if (!this.chart) {
      return
    }
    // if (this.autoResize) {
    //   window.removeEventListener('resize', this.__resizeHandler)
    // }
    this.chart.dispose()
    this.chart = null
  },
  methods: {
    setOptions({ xData, yData, title } = {}) {
      this.chart.setOption({
        backgroundColor: 'transparent', // 设置透明背景
        title: {
          text: title
        },
        grid: {
          top: 35,
          bottom: 30,
          right: 50,
          left: 30,
          containLabel: true
        },
        toolbox: {
          show: true,
          feature: {
            saveAsImage: {
              title: ''
            }
          }
        },
        dataZoom: [
          {
            type: 'slider',
            show: true,
            xAxisIndex: [0],
            handleSize: 0, // 滑动条的 左右2个滑动条的大小
            height: 10, // 组件高度
            left: 550, // 左边的距离
            right: 540, // 右边的距离
            bottom: 506, // 右边的距离
            handleColor: '#ddd' // h滑动图标的颜色
          },
          {
            type: 'inside',
            start: 0,
            end: 50,
            textStyle: {
              color: '#fff'
            }
          },
          {
            show: true,
            type: 'slider',
            // y: '94%',
            bottom: '0',
            start: 0,
            end: 50,
            textStyle: {
              color: '#fff'
            }
          }
        ],
        colorBy: 'series',
        xAxis: {
          type: 'category',
          data: xData,
          boundaryGap: true,
          axisLine: {
            lineStyle: { type: 'dashed', color: '#898a8a' }
          },
          axisLabel: {
            show: true, // 是否显示刻度标签，默认显示
            inside: false, // 刻度标签是否朝内，默认朝外
            margin: 6, // 刻度标签与轴线之间的距离
            fontSize: 8
          }
        },
        tooltip: {
          trigger: 'axis'
        },
        yAxis: {
          type: 'value',
          splitArea: false,
          axisLine: {
            lineStyle: { type: 'dashed', color: '#898a8a' }
          },
          splitLine: {
            show: true,
            lineStyle: { type: 'dashed', color: '#2b2c2c' }
          }
        },
        series: yData
      })
    },
    initChart() {
      this.chart = echarts.init(this.$el, 'macarons')
      this.setOptions(this.chartData)
    }
  }
}
</script>
